import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SWRConfig } from "swr";
import * as Sentry from "@sentry/react";
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router-dom";

if (process.env?.NODE_ENV !== "development") {
  console.log = function () {};
}

if (process.env.REACT_APP_MODE !== "development") {
  Sentry.init({
    enabled: process.env.REACT_APP_MODE !== "development",
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_MODE,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      // Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        blockAllMedia: false,
        maskAllText: false,
        maskAllInputs: false,
      }),
    ],
    // tracesSampleRate: 1.0,
    // tracePropagationTargets: ["localhost", "cambiu.me"],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      // console.log(hint);
      const error = hint.originalException;
      const noisePatterns = [
        /Warning:.*Each child in a list.*unique/i,
        /validateDOMNesting/i,
        /can't access lexical declaration/i,
        /React has been loaded more than once/i,
        /Failed prop type/i,
        /Encountered two children with the same key/i,
        /Warning:.*has no propTypes defined/i,
        /Warning:.*component is changing an uncontrolled input/i,
        /Warning:.*Cannot update a component while rendering a different component/i,
        /Warning:.*useLayoutEffect does nothing on the server/i,
        /URIError/i,
        /URI Error/i,
        /malformed URI/i,
        /ChunkLoadError/i,
      ];

      if (typeof error === "string" && noisePatterns.some((pattern) => pattern.test(error))) {
        return null;
      }
      return event;
    },
    beforeBreadcrumb(breadcrumb, hint) {
      const message = breadcrumb.message;
      const noisePatterns = [
        /Warning:.*Each child in a list.*unique/i,
        /validateDOMNesting/i,
        /can't access lexical declaration/i,
        /React has been loaded more than once/i,
        /Failed prop type/i,
        /Encountered two children with the same key/i,
        /Warning:.*has no propTypes defined/i,
        /Warning:.*component is changing an uncontrolled input/i,
        /Warning:.*Cannot update a component while rendering a different component/i,
        /Warning:.*useLayoutEffect does nothing on the server/i,
        /URIError/i,
        /URI Error/i,
        /malformed URI/i,
        /ChunkLoadError/i,
      ];

      if (noisePatterns.some((pattern) => pattern.test(message))) {
        return null;
      }
      return breadcrumb;
    },
  });
}

export const ERROR_MESSAGE = process.env?.NODE_ENV === "development" ? true : false;
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  // <App />
  // </React.StrictMode>
  <SWRConfig
    value={{
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }}
  >
    <App />
  </SWRConfig>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
